// extracted by mini-css-extract-plugin
export default {"games-page":"MjX2oTHKuko5qxGllbDlpA==","game-page":"Cl3T013pW7Z2qlFhcHRNEA==","game-loader":"ajpYJ4TLmWguqw9S4bf4oQ=="};